<template>
  <div class="w-[64px] h-[64px] bg-[#E8F5E9] rounded-full flex items-center justify-center mb-6">
    <ion-icon :icon="checkmarkCircleOutline" class="text-[2rem] text-[#4CAF50]"></ion-icon>
  </div>
  <h2 class="text-[1.5rem] font-bold leading-[2rem] text-center mb-10">
    {{ photoCount }} {{ photoCount === 1 ? 'photo' : 'photos' }} added!
  </h2>
  <button
    class="w-full max-w-[320px] py-[16px] bg-[#3D3A35] text-white rounded-full text-[1rem] font-semibold"
    @click="$emit('view')"
  >
    View Photos
  </button>
</template>

<script>
import { checkmarkCircleOutline } from 'ionicons/icons';

export default {
  name: 'ClaimSuccess',
  props: {
    photoCount: {
      type: Number,
      required: true,
    },
    resetLabel: {
      type: String,
      default: 'Try Again',
    },
  },
  emits: ['view', 'reset'],
  created() {
    this.checkmarkCircleOutline = checkmarkCircleOutline;
  },
};
</script>
